import React from 'react';
import {Container, Card, Row, Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/styles/C911Ced.scss';
import { useSelector } from 'react-redux';
import {CabezaCedula,IdentEsc,VersionCifras,PieCedula,ClaveEsc,CicloCenso,TotalAlumnos,Separador,SumaSet,NotaAula,TurnoNombre,ActHojas} from './ToolsCed';

let tothoja=0;

function PersnivelPrim(cvesubnivel,docfis,docart,doctec,docleng,admvo,promotor,estiloborde){
  switch (cvesubnivel) {
    case "1":
      return (
        <Row>
          <Col xs={12}>
            <Row className="no-gutters margeninf">
              <Col xs={10} className="font-weight-bold">Personal Docente Especial</Col>
              <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{SumaSet([docfis,docart,doctec,docleng])}</Col>            
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={1} className="bordetransparente"></Col>
              <Col xs={9} className="bordetransparente">Prof. de educación física</Col>
              <Col xs={2} className={`${estiloborde} text-center`}>{docfis}</Col>
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={1} className="bordetransparente"></Col>
              <Col xs={9} className="bordetransparente">Prof. de acts. artísticas</Col>
              <Col xs={2} className={`${estiloborde} text-center`}>{docart}</Col>
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={1} className="bordetransparente"></Col>
              <Col xs={9} className="bordetransparente">Prof. de acts. tecnológicas</Col>
              <Col xs={2} className={`${estiloborde} text-center`}>{doctec}</Col>
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={1} className="bordetransparente"></Col>
              <Col xs={9} className="bordetransparente">Prof. de idiomas</Col>
              <Col xs={2} className={`${estiloborde} text-center`}>{docleng}</Col>
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={10} className="font-weight-bold bordetransparente">Personal Admvo. y de Servs.</Col>
              <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{admvo}</Col>            
            </Row>
          </Col>
        </Row>)
    case "3":
      return (
        <Row>
          <Col xs={12}>
            <Row className="no-gutters margeninf">
              <Col xs={10} className="font-weight-bold bordetransparente"><p>Promotores</p></Col>
              <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}><p>{promotor}</p></Col>            
            </Row>
            <Row className="no-gutters margeninf">
              <Col xs={10} className="font-weight-bold bordetransparente"><p>Pers. Admvo.,Aux. y de Servs.</p></Col>
              <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}><p>{admvo}</p></Col>            
            </Row>
          </Col>
        </Row>)
    default:
      return [];
  }
}

function DatosCifrasPrim(props){
  const { fechac911 } = useSelector((state) => state.esc);
  let hojent=0;
  let hojfracc=0;
  let numhoja=0;
  let reg1hoja=0;
  let poselem=props.indice+1;

  if (poselem<=2){
    numhoja=1;
  }else{
    hojent=Math.trunc((poselem-2)/props.regxanexo);
    hojfracc=(poselem-2) % props.regxanexo;
    if (hojfracc>0){
      hojfracc=1;
    }
    numhoja=1+hojent+hojfracc;
  }
  if (numhoja<=1){
    reg1hoja=1;
  }else{
    reg1hoja=(numhoja-1)*props.regxanexo;
  }
  if (numhoja>tothoja){
    tothoja=numhoja;
  }
  let estilodato="";
  let estiloborde="borde";
  let descrsecci="I. ALUMNOS, GRUPOS, DOCENTES Y AULAS";
  if (fechac911[0].fuente==='CONTROL'){
    estilodato="sintexto";
    estiloborde="sinborde";
    descrsecci="I. ALUMNOS";
  }
  return (
    <div id={(Math.floor(Math.random*50)).toString()}>
      {Separador (poselem,reg1hoja)}
      {TurnoNombre([props.cifras.turno,props.cifras.turno1,props.cifras.turno2,props.cifras.turno3])}
      <Row><Col xs={12}><h6 className="font-weight-bold">{descrsecci}</h6></Col></Row>                        
      <Row>
        <Col xs={8}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={2}><p>&nbsp;</p></Col>
                <Col xs={1}><p>1°</p></Col>
                <Col xs={1}><p>2°</p></Col>
                <Col xs={1}><p>3°</p></Col>
                <Col xs={1}><p>4°</p></Col>
                <Col xs={1}><p>5°</p></Col>
                <Col xs={1}><p>6°</p></Col>
                <Col xs={2} className={`${estilodato}`}><p>+ de 1 grado</p></Col>
                <Col xs={2}><p>Total</p></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={2} className="bordetransparente text-left"><p>Alumnos</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.alum1}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.alum2}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.alum3}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.alum4}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.alum5}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.alum6}</p></Col>
                <Col xs={2} className={`${estilodato} ${estiloborde}`}><p>{props.cifras.alumn}</p></Col>
                <Col xs={2} className="borde"><p>{props.cifras.alumtot}</p></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={2} className="bordetransparente text-left"><p>Grupos</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.grupo1}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.grupo2}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.grupo3}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.grupo4}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.grupo5}</p></Col>
                <Col xs={1} className="borde"><p>{props.cifras.grupo6}</p></Col>
                <Col xs={2} className={`${estilodato} ${estiloborde}`}><p>{props.cifras.grupon}</p></Col>
                <Col xs={2} className="borde"><p>{props.cifras.grupotot}</p></Col>            
              </Row>
              <Row className={`no-gutters text-center margeninf ${estilodato}`}>
                <Col xs={2} className="bordetransparente text-left"><p>Docentes frente a grupo</p></Col>
                <Col xs={1} className={`${estiloborde}`}><p>{props.cifras.doc1}</p></Col>
                <Col xs={1} className={`${estiloborde}`}><p>{props.cifras.doc2}</p></Col>
                <Col xs={1} className={`${estiloborde}`}><p>{props.cifras.doc3}</p></Col>
                <Col xs={1} className={`${estiloborde}`}><p>{props.cifras.doc4}</p></Col>
                <Col xs={1} className={`${estiloborde}`}><p>{props.cifras.doc5}</p></Col>
                <Col xs={1} className={`${estiloborde}`}><p>{props.cifras.doc6}</p></Col>
                <Col xs={2} className={`${estiloborde}`}><p>{props.cifras.docn}</p></Col>
                <Col xs={2} className={`${estiloborde}`}><p>{props.cifras.doctot}</p></Col>            
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="text-center">
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={6}><p>Hom</p></Col>
                <Col xs={6}><p>Muj</p></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={6} className="borde"><p>{props.cifras.alumhom}</p></Col>
                <Col xs={6} className="borde"><p>{props.cifras.alummuj}</p></Col>          
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className={`${estilodato}`}>
            <Col xs={12}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={8}><p>&nbsp;</p></Col>
                <Col xs={4}><p>Aulas</p></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8} className="bordetransparente"><p>Existentes</p></Col>
                <Col xs={4} className={`text-center ${estiloborde}`}><p>{props.cifras.aulaexis}</p></Col>          
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8} className="bordetransparente"><p>En Uso</p></Col>
                <Col xs={4} className={`text-center ${estiloborde}`}><p>{props.cifras.aulauso}</p></Col>         
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8} className="bordetransparente"><p>Adaptadas</p></Col>
                <Col xs={4} className={`text-center ${estiloborde}`}><p>{props.cifras.aulaadap}</p></Col>           
              </Row>
              <Row className="margensupaula">
                <Col xs={12} className="text-left">
                  <p className="fontmaspeque">{NotaAula()}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="margeninf">
        <Col xs={10}></Col>
        <Col xs={2} className="text-left">
          <p className="fontmaspeque">&nbsp;</p>
        </Col>
      </Row>
      <Row><Col xs={12}><h6 className={`${estilodato} font-weight-bold`}>II. PERSONAL POR FUNCIÓN</h6></Col></Row>
      <Row className={`${estilodato}`}>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold">Personal Directivo</Col>
                <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{SumaSet([props.cifras.dircgpo,props.cifras.dirsgpo,props.cifras.dirgest,props.cifras.diracad])}</Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Con grupo</Col>
                <Col xs={2}  className={`${estiloborde} text-center`}>{props.cifras.dircgpo}</Col> 
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Sin grupo</Col>
                <Col xs={2} className={`${estiloborde} text-center`}>{props.cifras.dirsgpo}</Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Subdirector de gestión</Col>
                <Col xs={2} className={`${estiloborde} text-center`}>{props.cifras.dirgest}</Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente">Subdirector académico</Col>
                <Col xs={2} className={`${estiloborde} text-center`}>{props.cifras.diracad}</Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold bordetransparente">Personal docente</Col>
                <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{props.cifras.doc}</Col>            
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={4}>
          {PersnivelPrim(
              props.cifras.cvesubnivel,
              props.cifras.docfis,
              props.cifras.docart,
              props.cifras.doctec,
              props.cifras.docleng,
              props.cifras.admvo,
              props.cifras.promotor,
              estiloborde)}
        </Col>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={7} className="font-weight-bold bordetransparente">Total de Personal</Col>
                <Col xs={2} className={`${estiloborde} text-center font-weight-bold`}>{props.cifras.perstot}</Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

function LlenaCedula(){
  //const { estad, fechac911 } = useSelector((state) => state.esc);
  const { estad } = useSelector((state) => state.esc);
  let cadena=[];
  let reg=0;
  let regcct=2;
  let regxanexo=3;
  let anexos=0;
  let anexolleno=0;
  let regsinanexo=0;
  let lianexo=0;
  let lsanexo=0;
  let cuerpo;
  const Ciclo=CicloCenso(1);
  reg=estad.length;
  ActHojas(reg,regcct,regxanexo);
  if (reg>0){
    if (reg<=2){
      cuerpo=estad.map((items,index) => <DatosCifrasPrim cifras={items} regxanexo={regxanexo} indice={index}/>);
      cadena.push(
      <div id={(Math.floor(Math.random*50)).toString()}>
        <CabezaCedula/>
        <IdentEsc/>
        <Card border="dark" style={{ width: 'auto' }}>
          {/*<Card.Header className="text-center font-weight-bold">ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>*/}
          <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
          <Card.Body>
            <TotalAlumnos escuela={estad}/>
            {cuerpo}
          </Card.Body>
        </Card>
        <PieCedula/>
      </div>);
    }else{
      cuerpo=estad.map((items,index) => ((index>=0) && (index<=1))?<DatosCifrasPrim cifras={items} regxanexo={regxanexo} indice={index}/>:[]);
      cadena.push(
        <div id={(Math.floor(Math.random*50)).toString()}>
          <CabezaCedula/>
          <IdentEsc/>
          <Card border="dark" style={{ width: 'auto' }}>
            <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
            <Card.Body>
              <TotalAlumnos escuela={estad}/>
              {cuerpo}
            </Card.Body>
          </Card>
          <PieCedula/>
        </div>);  
      anexos=(reg-regcct)/regxanexo;
      anexolleno=Math.trunc(anexos);
      regsinanexo=reg-regcct-(anexolleno*regxanexo);
      lianexo=regcct; /* comienza a partir del registro 2 y omite los registros 0 y 1 */
      lsanexo=regcct+regxanexo-1; /* abarca hasta el 4° registro incluyendo el registro 2 */
      if (anexolleno>0) {
        //anexos llenos
        for (let ii=1; ii <= anexolleno; ii++) {
          cuerpo=estad.map((items,index) => ((index>=lianexo) && (index<=lsanexo))?<DatosCifrasPrim cifras={items} regxanexo={regxanexo} indice={index}/>:[])
          cadena.push(
            <div id={(Math.floor(Math.random*50)).toString()}>
              <CabezaCedula/>
              <Card border="dark" style={{ width: 'auto'}}>
                <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
                <Card.Body>
                  <ClaveEsc cvect={estad[0].cvect}/>
                  {cuerpo}
                </Card.Body>
              </Card>
              <PieCedula/>
            </div>);
          lianexo=lianexo+regxanexo;
          lsanexo=lsanexo+regxanexo;
        }
      }else{
        lsanexo=regcct+regsinanexo-1; /* abarca hasta el N registro incluyendo el registro 2 */
      }
      if (regsinanexo>0) {
        //anexos llenos
        cuerpo=estad.map((items,index) => ((index>=lianexo) && (index<=lsanexo))?<DatosCifrasPrim cifras={items} regxanexo={regxanexo} indice={index}/>:[]);
        cadena.push(
          <div id={(Math.floor(Math.random*50)).toString()}>
            <CabezaCedula/>
            <Card border="dark" style={{ width: 'auto'}}>
              <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
              <Card.Body>
                <ClaveEsc cvect={estad[0].cvect}/>
                {cuerpo}
              </Card.Body>
            </Card>
            <PieCedula/>
          </div>);
      }
    }
  }
  return cadena;
} //LlenaCedula  

class CedPrim extends React.Component {
  render(){
    return (
      <div id='capcedprim'>
        <Container padding="4rem">
          <LlenaCedula/>
        </Container>
      </div>
    )
  }
}
export default CedPrim;